import uk.co.nickthecoder.kyd.Actor

class Fuel : Collectable() {

    override fun collect(collectedActor: Actor) {
        super.collect(collectedActor)
        PlayDirector.instance.collectedFuel()
    }

}
